import { selectUserOrgByApp } from '@rsos/sinatra';
import { postIssueComment } from '../../services/capstone';
import {
  CREATE_ISSUE_COMMENT_SUCCESS,
  CREATE_ISSUE_COMMENT_START,
  CREATE_ISSUE_COMMENT_FAILED,
} from '../actionTypes';

export const createIssueCommentStart = () => ({
  type: CREATE_ISSUE_COMMENT_START,
});

export const createIssueCommentSuccess = issue => ({
  type: CREATE_ISSUE_COMMENT_SUCCESS,
  issue,
});

export const createIssueCommentFailed = error => ({
  type: CREATE_ISSUE_COMMENT_FAILED,
  error,
});

/**
 * Posts a comment to the given issue.
 * @param {Object} issue - The issue object
 * @param {string} issue.issue_key - The key for the issue
 * @param {Object} comment - The comment to be posted
 * @param {string} comment.body - The body of the comment as a string.
 */
const createIssueComment = (issue, comment) => (dispatch, getState) => {
  const { sinatra } = getState();
  const application = sinatra.user.currentRole.application;
  const org = selectUserOrgByApp(sinatra, application);

  dispatch(createIssueCommentStart());
  return postIssueComment(issue, org.name, comment)
    .then(postedComment => {
      const updatedIssue = {
        ...issue,
        comments: [...issue.comments, postedComment],
      };
      return dispatch(createIssueCommentSuccess(updatedIssue));
    })
    .catch(error => {
      throw dispatch(createIssueCommentFailed(error));
    });
};

export default createIssueComment;
